module.exports = __webpack_public_path__ + "img/LKTin_Sirop_Gray_1280x1010.ebc6f5f6.jpg";